export default "__VITE_ASSET__dd5b0eab__"